import { createFileRoute, Link } from "@tanstack/react-router";

import { ProductShell } from "@/components/app/product-shell";
import { ErrorBoundary } from "@/components/error-boundary";
import { BugReportWidget } from "@/components/bug-report";
import { QuickDealDesk } from "@/components/quick-deal-desk";
import { DealWorkbench } from "@/components/app/deal-workbench";

export const Route = createFileRoute("/_authenticated/app/analyze")({
  head: () => ({
    meta: [
      { title: "Analyze a deal — AROS FLOW" },
      {
        name: "description",
        content:
          "Run a property through ARV, repairs and maximum allowable offer with sources, confidence and fully editable assumptions.",
      },
      { property: "og:title", content: "Analyze a deal — AROS FLOW" },
      {
        property: "og:description",
        content: "ARV, repairs and offer range with editable assumptions and a confidence read.",
      },
      { property: "og:type", content: "website" },
    ],
  }),
  component: AnalyzePage,
});

function AnalyzePage() {
  return (
    <ProductShell
      title="Analyze"
      subtitle="Property facts, ARV, repairs and the offer range. Every number is editable and every recommendation shows its reasoning."
    >
      <ErrorBoundary label="Analyze crashed">
        <DealWorkbench />
      </ErrorBoundary>

      <details className="mt-8 rounded-xl border border-[var(--glass-border)] bg-card p-4">
        <summary className="focus-key cursor-pointer text-xs font-semibold text-gold">
          Open the fast call desk — same maths, card by card, built for talking live
        </summary>
        <div className="mt-4">
          <ErrorBoundary label="Deal desk crashed">
            <QuickDealDesk />
          </ErrorBoundary>
        </div>
      </details>

      <p className="mt-6 text-[11px] text-muted-foreground">
        Prefer the standalone estimators?{" "}
        <Link to="/penthouse" className="focus-key text-gold hover:underline">
          The classic tools are still here.
        </Link>
      </p>
      <BugReportWidget />
    </ProductShell>
  );
}
